// Keyset listelerinin alt çubuğu (SEM-5327). Uç OFFSET almıyor; imleç yalnız
// ileri yönü bilir, bu yüzden "önceki" ziyaret edilen imleçlerin yığınıyla
// çalışır: sondaki eleman GÖRÜNEN sayfayı getiren imleç, boş yığın ilk sayfa.

import { useCallback, useState } from "react";
import { useTranslation } from "react-i18next";

import { Button } from "@novemai/components";

export interface CursorStack {
  readonly cursor: string | null;
  readonly depth: number;
  readonly push: (next: string) => void;
  readonly pop: () => void;
  readonly reset: () => void;
}

export function useCursorStack(): CursorStack {
  const [stack, setStack] = useState<readonly string[]>([]);
  // Sabit kimlikli: `reset` süzgeç debounce efektlerinin bağımlılığında duruyor.
  const push = useCallback((next: string): void => setStack((prev) => [...prev, next]), []);
  const pop = useCallback((): void => setStack((prev) => prev.slice(0, -1)), []);
  const reset = useCallback((): void => setStack([]), []);
  return { cursor: stack.at(-1) ?? null, depth: stack.length, push, pop, reset };
}

export function CursorPager({
  stack,
  shown,
  total,
  nextCursor,
  busy,
}: {
  readonly stack: CursorStack;
  readonly shown: number;
  readonly total: number;
  readonly nextCursor: string | null;
  readonly busy: boolean;
}): React.ReactElement {
  const { t } = useTranslation();
  return (
    // Sarmalama: 375px'te sayım ile sağdaki eşi sıfır boşlukta birbirine
    // değiyordu (SEM-4931).
    <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-2 border-t border-[var(--border-subtle)] px-[18px] py-3">
      <span className="font-sans text-xs text-[var(--fg-muted)]">
        {t("common.showing", { count: shown, total })}
      </span>
      <div className="flex gap-1.5">
        <Button
          variant="secondary"
          size="sm"
          disabled={stack.depth === 0 || busy}
          onClick={stack.pop}
        >
          {t("common.previous")}
        </Button>
        <Button
          variant="secondary"
          size="sm"
          disabled={nextCursor === null || busy}
          onClick={(): void => {
            if (nextCursor !== null) stack.push(nextCursor);
          }}
        >
          {t("common.next")}
        </Button>
      </div>
    </div>
  );
}
